import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <h3 className="footer-title">Dynamic Professional Skills</h3>
            <p className="footer-description">
              Empowering students through comprehensive Olympiad exams. 
              Fostering excellence in education across disciplines.
            </p>
          </div>
          
          <div className="footer-links-col">
            <h4 className="footer-subtitle">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/olympiads">Our Olympiads</Link></li>
              <li><Link to="/results">Results</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/faq">FAQs</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/refund-and-cancellation">Refund Policy</Link></li>
            </ul>
          </div>
          
          <div className="footer-contact">
            <h4 className="footer-subtitle">Contact Us</h4>
            <ul className="contact-list">
              <li>
                <MapPin size={18} />
                <span>212/1, Shanti Niketan, Dampier Nagar, Mathura, Uttar Pradesh - 281001</span>
              </li>

              <li>
                <Mail size={18} />
                <a href="mailto:mathuraolympiads@gmail.com" style={{ color: 'inherit', textDecoration: 'none' }}>mathuraolympiads@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Dynamic Professional Skills. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
